var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSearchRealEstate = function SvgIconSearchRealEstate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "481pt",
    viewBox: "0 0 481.94818 481",
    width: "481pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m328 168.472656c0 88.367188-71.632812 160-160 160s-160-71.632812-160-160c0-88.363281 71.632812-160 160-160 42.476562-.128906 83.25 16.683594 113.28125 46.71875 30.035156 30.035156 46.851562 70.808594 46.71875 113.28125zm0 0",
    fill: "#96c8ef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m248 139.195312v125.277344c0 4.417969-3.582031 8-8 8h-144c-4.417969 0-8-3.582031-8-8v-125.277344l80-58.722656zm0 0",
    fill: "#ffc477"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m464 416.472656c12.960938 13.304688 12.824219 34.558594-.308594 47.691406-13.136718 13.132813-34.386718 13.273438-47.691406.308594l-72-72c-12.960938-13.300781-12.824219-34.554687.308594-47.6875 13.136718-13.136718 34.386718-13.273437 47.691406-.3125zm0 0",
    fill: "#00ccb3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m192 208.472656h32v32h-32zm0 0",
    fill: "#e6e7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m120 208.472656h48v64h-48zm0 0",
    fill: "#8b5e3c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m192 152.472656c0 13.257813-10.746094 24-24 24s-24-10.742187-24-24c0-13.253906 10.746094-24 24-24s24 10.746094 24 24zm0 0",
    fill: "#ffd422"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m176 86.3125-72 52.882812-16 11.757813v-11.757813l80-58.722656zm0 0",
    fill: "#ffb655"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m192 208.472656h16v32h-16zm0 0",
    fill: "#d1d3d4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m120 208.472656h16v64h-16zm0 0",
    fill: "#754c29"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m120 208.472656h48v8h-48zm0 0",
    fill: "#754c29"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m298.71875 148.152344c-.007812 5.398437-3.046875 10.332031-7.859375 12.765625-4.816406 2.429687-10.589844 1.953125-14.9375-1.242188l-27.921875-20.480469-80-58.722656-80 58.722656-27.921875 20.480469c-2.445313 1.761719-5.382813 2.714844-8.398437 2.71875-4.796876 0-9.285157-2.367187-12-6.320312-4.253907-6.457031-2.625-15.125 3.679687-19.601563l124.640625-88 124.640625 88c3.792969 2.6875 6.054687 7.035156 6.078125 11.679688zm0 0",
    fill: "#ff6243"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m224 248.472656h-32c-4.417969 0-8-3.582031-8-8v-32c0-4.417968 3.582031-8 8-8h32c4.417969 0 8 3.582032 8 8v32c0 4.417969-3.582031 8-8 8zm-24-16h16v-16h-16zm0 0",
    fill: "#754c29"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1e81ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168 336.472656c-92.785156 0-168-75.214844-168-168 0-92.78125 75.214844-168 168-168s168 75.21875 168 168c-.105469 92.742188-75.261719 167.894532-168 168zm0-320c-83.949219 0-152 68.054688-152 152 0 83.949219 68.050781 152 152 152s152-68.050781 152-152c-.09375-83.90625-68.089844-151.90625-152-152zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 482.394531c-11.125.019531-21.796875-4.394531-29.65625-12.265625l-72-72c-16.378906-16.378906-16.378906-42.933594 0-59.3125 16.378906-16.375 42.933594-16.375 59.3125 0l72 72c12 11.992188 15.59375 30.03125 9.097656 45.703125-6.492187 15.671875-21.789062 25.886719-38.753906 25.875zm-72-139.847656c-10.492188-.007813-19.957031 6.308594-23.972656 16.003906-4.015625 9.691407-1.796875 20.851563 5.628906 28.265625l72 72c10.164062 9.9375 26.429688 9.84375 36.480469-.203125 10.050781-10.050781 10.144531-26.320312.207031-36.484375l-72-72c-4.863281-4.867187-11.464844-7.59375-18.34375-7.582031zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.484375 287.269531 11.3125-11.3125 62.859375 62.859375-11.3125 11.3125zm0 0"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSearchRealEstate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-search-real-estate.26c688a0.svg";
export { ForwardRef as ReactComponent };